export default __webpack_public_path__ + "static/media/james.ee4d9b57.jpg";